import React from 'react';
import { connect } from 'react-redux';
import SettingsPageLayout from './SettingsPageLayout';
import ImportSection from '../onboarding/ImportSection';
import { openOnboardingLayer } from '../onboarding/ImportJobContext';
import { ONBOARDING_ENABLED } from '../onboarding/flags';
import { canImport } from '../permissions/access';
import './SettingsModern.css';
import './ImportData.css';

/**
 * Settings → Import your data. The eye-catching entry to the same "Bring
 * more in" screen the sign-up onboarding uses, plus the import history
 * (undo within 72 hours) underneath.
 */
export function ImportHero({ compact }) {
  // Owner, `settings`, or a self-employed stylist's own book (the server's rule).
  if (!ONBOARDING_ENABLED || !canImport()) return null;
  return (
    <button type="button" className={`imp-hero${compact ? ' imp-hero--compact' : ''}`} onClick={() => openOnboardingLayer({ mode: 'import' })}>
      <span className="imp-hero-float imp-hero-float--csv" aria-hidden="true">.csv</span>
      <span className="imp-hero-float imp-hero-float--xlsx" aria-hidden="true">.xlsx</span>
      <span className="imp-hero-text">
        <span className="imp-hero-eyebrow">Import your data</span>
        <span className="imp-hero-h1">Bring in more.</span>
        <span className="imp-hero-h2">Anything you've got, we'll <em>sort</em> it.</span>
        {!compact && <span className="imp-hero-p">Client lists, price lists, product sheets, your team, a photo of your appointment book. Drop it in and we merge it with what you already have.</span>}
      </span>
      <span className="imp-hero-cta">Bring in your data</span>
    </button>
  );
}

function ImportData(props) {
  return (
    <SettingsPageLayout activeTab="import-data" {...props}>
      <div className="catalogue-content-wrapper imp-page">
        <ImportHero />
        <div className="settings-card">
          <div className="settings-card-header">
            <h2>Good to know</h2>
          </div>
          <ul className="imp-notes">
            <li>CSV, Excel, PDF and photos. Up to 10 files, 25 MB each.</li>
            <li>Duplicates are matched on phone and email and offered to you to merge, never merged silently.</li>
            <li>Nothing is sent to your clients, and marketing consent is never assumed.</li>
            <li>Every import can be undone for 72 hours.</li>
          </ul>
        </div>
        <ImportSection historyOnly />
      </div>
    </SettingsPageLayout>
  );
}

export default connect((state) => ({ user: state.user }))(ImportData);
